import {Component, OnInit} from '@angular/core';
import {DialogService} from 'primeng/api';
import {VersionComponent} from '@app/core/version/version.component';
import {VersionService} from '@app/shared/services/version.service';
import {VersionModel} from '@app/shared/model/VersionModel';

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent {


  constructor(
    private dialogSrv: DialogService,
  ) {
  }


  showVersionInfo() {
    const dialogRef = this.dialogSrv.open(VersionComponent, {
      width: '400px'
    });

  }
}
